import { Component, OnInit, ElementRef, OnChanges, AfterViewInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { VendorSetupInternational } from './../../../models/VendorSetupInternational';
import { NgForm, FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { VendorService } from './../../../services/vendor.service';
import { DataService } from './../../../services/data.service';
import { AccountService } from './../../../services/account.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TaxForm } from './../../../models/TaxForm';
import { TaxFormFile } from './../../../models/TaxFormFile';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ModalComponent } from './../../../shared-components/modal/modal.component';
import * as njq from 'jquery';

@Component({
  selector: 'app-international-vendor-form',
  templateUrl: './international-vendor-form.component.html',
  styleUrls: ['./international-vendor-form.component.scss']
})
export class InternationalVendorFormComponent implements OnInit {

  @ViewChild('submitCancel') submitCancel: ModalComponent;

  public vendorSetup: VendorSetupInternational = new VendorSetupInternational();
  public isCustomer: any = ['yes', 'no'];
  public currencyArray: any;
  public countryArray: any;
  errorMsg: string;
  showFailConfirmation: boolean;
  showSuccessConfirmation = false;
  public fileData: Uint8Array;
  showInvalidFileMessage = false;
  InvalidFileMessage: string;
  alive = true;
  reader: FileReader = new FileReader();
  taxForm: TaxForm = new TaxForm();
  taxFromFile: TaxFormFile = new TaxFormFile();
  inputVariable: any;
  paymentTerms = [
    'Due Upon Receipt',
    'Net 7',
    'Net 10',
    'Net 15',
    'Net 20',
    'Net 25',
    'Net 30',
    'Net 45'
  ];

  public paymentMethodTypeArray:any = [
  {'name': 'CHECK', 'value': 'CHK'}
  , {'name': 'CREDIT CARD', 'value': 'CC'}
  , {'name': 'WIRE', 'value': 'WIR'}
  ];
  
  constructor(private dataSvc: DataService,
    private vendorSvc: VendorService,
    private accountSvc: AccountService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private spinner: NgxSpinnerService) {
    this.vendorSetup.PaymentTerms = 'Net 30';
    this.accountSvc.getCurrencyList()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.currencyArray = data;
          console.log(this.currencyArray);
        },
        err => {
          this.errorMsg = err;
        },
        () => console.log('Request Complete')
      );

    this.accountSvc.getCountryList()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.countryArray = data;
          console.log('countries', this.countryArray);
        },
        err => {
          this.errorMsg = err;
        },
        () => {
          console.log('Request Complete');
          this.spinner.hide();
        }
      );

  }

  ngOnInit() {

  }
  goToPreviousPage() {
    this._location.back();
  }

  onModalSubmit(frmVendorSetup: NgForm) {
    this.accountSvc.createVendorCreateRequest(this.vendorSetup)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);
          this.spinner.hide();
          this.showSuccessConfirmation = true;
          this.onModalClose();
        },
        err => {
          this.errorMsg = err;
          this.spinner.hide();
          this.showFailConfirmation = true;
          this.onModalClose();
        },
        () => {
          console.log('Request Complete');
          njq(".router-content").animate({ scrollTop: 0 }, "fast");
          this.spinner.hide();
        }
      );
  }

  onModalClose(){
    this.submitCancel.hide();
  }

  onSubmit(frmVendorSetup: NgForm) {
    
    if(this.vendorSetup.FileName == null || this.vendorSetup.FileName == undefined || this.vendorSetup.FileName == '' ) {
      console.log('Submit  activated', JSON.stringify(frmVendorSetup.value));
      this.submitCancel.show();

    } else {
      console.log('Submit  activated', JSON.stringify(frmVendorSetup.value));
      this.spinner.show();
    this.accountSvc.createVendorCreateRequest(this.vendorSetup)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);
          this.spinner.hide();
          this.showSuccessConfirmation = true;
        },
        err => {
          this.errorMsg = err;
          this.spinner.hide();
          this.showFailConfirmation = true;
        },
        () => {
          console.log('Request Complete');
          njq(".router-content").animate({ scrollTop: 0 }, "fast");
          this.spinner.hide();
        }
      );
    }
    
  }

  redirectToVendorSetup(event) {
    this.router.navigate(['/pages/vendor-setup']);
  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  wait2sec() {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        resolve();
      }, 2000);
    });
  }

  resetFileInput() {
    this.inputVariable.nativeElement.value = '';
  }

  readFile(files: FileList) {
    this.reader.onload = e => {
      this.fileData = new Uint8Array(this.reader.result);
    };
    /*this.reader.onprogress = function(data) {
      if (data.lengthComputable) {
        let progress = parseInt( ((data.loaded / data.total) * 100), 10 );
        console.log()
      }
    }*/
    console.log(files[0]);
    this.reader.readAsArrayBuffer(files[0]);
  }

  arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const len = buffer.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary);
  }

  checkFileExt(fileExt: string): boolean {
    // tslint:disable-next-line:max-line-length
    if (!fileExt.match(/.jpg|.jpeg|.bmp|.png|.gif|.tiff|.pdf|.doc|.docx|.xls|.xlsx|.JPG|.JPEG|.BMP|.PNG|.GIF|.TIFF|.PDF|.DOC|.DOCX|.XLS|.XLSX/i)) {
      return false;
    }
    return true;
  }

  async handleFileInput(files: FileList) {
    console.log('first log');
    this.showInvalidFileMessage = false;
    if (files.length !== 1) {
      console.log('Only support upload 1 file');
      this.resetFileInput();
      return;
    }
    // File size limit, 11M
    if (files[0].size > 11534336) {
      this.InvalidFileMessage = 'This file\'s size exceeds the limit';
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    console.log('Inside handle');
    console.log(files.length);
    const fileExt = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase();
    console.log('After handle');
    if (!this.checkFileExt(fileExt)) {
      console.log('Unsupport this kind of file');
      this.InvalidFileMessage = 'We don\'t support ' + fileExt + ' file';
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    this.spinner.show();
    this.readFile(files);
    await this.wait2sec();
    this.taxForm.FileName = Date.now().toString() + fileExt;
    this.taxForm.AttachmentFilePath = this.taxFromFile.fileName;
    // this.questionFile.fileData = btoa(this.fileData.reduce((data, byte) => data  + String.fromCharCode(byte), ''));
    // this.taxFromFile.fileData = this.arrayBufferToBase64(this.fileData);
    this.vendorSetup.FileBytesBase64 = this.arrayBufferToBase64(this.fileData);
    this.vendorSetup.FileName = this.taxForm.FileName;
    this.spinner.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor-setup/international-vendor-form/international-vendor-form.component.ts